export const NOTIFICATIONS_FEATURE_FLAG = {
  CHAT_SMS: 'MEMBER-CHAT-SMS-NOTIFICATIONS',
};
